import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Widgets } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Nombre almacén', accessor: 'name' },
  { Header: 'Tipo', accessor: 'warehouse_type' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Warehouse(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [warehouses, setWarehouses] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadWarehouses() {
    setDataLoading(true);
    let response = await wsGetAll('logi/warehouse');
    setDataLoading(false);
    if (response.success) setWarehouses(response.data);
  }

  useEffect(() => {
    loadWarehouses();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadWarehouses} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_WAREHOUSES_STORE}
              component={
                <CardIcon color={props.themeContext.buttonColor}>
                  <Widgets />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>

            <h4 className={classes.cardIconTitle}>Listado de Almacenes {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Almacenes"
              defaultWidth={1000}
              indexRow={[0, 1, 3, 4, 5, 6]}
              widthRow={[120, 100, 120, 180, 120, 5]}
              columns={columns}
              data={warehouses.map((warehouse, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_WAREHOUSES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(warehouse)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_WAREHOUSES_DELETED}>
                        <ButtonDelete
                          entity="logi/warehouse"
                          id={warehouse.id}
                          reload={loadWarehouses}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: warehouse.WhsCode,
                  name: warehouse.WhsName,
                  warehouse_type: warehouse.warehouse_type === 'N' ? 'Normal' : 'Malogrado',
                  base_zone_description: warehouse.base_zone_description,
                  state: warehouse.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
